<div class="text-center">
  <i class="fa fa-sign-out fa-5x mt-5"></i>
  <p class="m-2 mb-5">{{message}}</p>
</div>
